import React from 'react'
import styles from './Stats.scss'
import {QuickStats} from 'features/experiences/QuickStats'
import {apiv3} from 'lib/apiv3'

export class Stats extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      stats: null
    }
  }

  componentDidMount () {
    const {experience} = this.props
    apiv3.experiences.stats(experience.id)
      .then(({stats}) => { this.setState({stats}) })
  }

  render () {
    const {stats} = this.state

    return (
      <div className={styles.Stats}>
        {stats && <QuickStats totals={stats} rows={2} labelsUnder bottomMargin />}
      </div>
    )
  }
}
